import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { FormBuilder, Validators } from '@angular/forms';
import { DatabaseService } from 'src/app/services/database.service';

@Component({
    selector: 'app-add-notification',
    templateUrl: './add-notification.component.html',
    styleUrls: ['./add-notification.component.scss'],
    standalone: false
})
export class AddNotificationComponent {
  form: any;
  processing = false;

  // ✅ NEW QUILL CONFIG (replacement of AngularEditorConfig)
  editorModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],

      [{ header: [1, 2, 3, false] }],

      [{ list: 'ordered' }, { list: 'bullet' }],

      [{ indent: '-1' }, { indent: '+1' }],

      [{ color: [] }, { background: [] }],

      [{ align: [] }],

      ['link', 'image'],

      ['clean']
    ]
  };

  editorPlaceholder = 'Enter text here...';

  constructor(
    private dialogRef: MatDialogRef<AddNotificationComponent>,
    private fb: FormBuilder,
    private db: DatabaseService
  ) {
    this.form = this.fb.group({
      title: ['', Validators.required],
      message: ['', Validators.required],
      app: ['0', Validators.required],
      url: ['', Validators.required],
      version: ['', Validators.required],
      upgrade_message: [false],
      critical: [false],
      testonly: [false]
    });
  }

  ngOnInit(): void {}

  save() {
    if (!this.processing) {
      this.processing = true;

      let ts = Math.round(new Date().getTime() / 1000);
      let app = this.form.controls.app.value;
      let platform = 'IOS';

      if (app == '1') {
        platform = 'Android';
      }

      if (this.form.controls.testonly.value) {
        platform = 'isTestOnly/' + platform;
      }

      this.db.addNotification(platform, 'notification_' + ts, {
        appNewVersion: this.form.controls.version.value,
        date: new Date(),
        isAppUpgradeMessage: this.form.controls.upgrade_message.value,
        isCritical: this.form.controls.critical.value,
        notificationtitle: this.form.controls.title.value,
        notificationmessage: this.form.controls.message.value,
        url: this.form.controls.url.value
      }).then(() => {

        this.db.sendMessage({
          topic: platform,
          notificationtitle: this.form.controls.title.value,
          notificationmessage: this.form.controls.message.value,
        }).subscribe(() => {});

        this.dialogRef.close(true);
        this.processing = false;
      });

      if (app == '2') {
        this.db.addNotification(
          (this.form.controls.testonly.value ? 'isTestOnly/' : '') + 'Android',
          'notification_' + ts,
          {
            appNewVersion: this.form.controls.version.value,
            date: new Date(),
            isAppUpgradeMessage: this.form.controls.upgrade_message.value,
            isCritical: this.form.controls.critical.value,
            notificationtitle: this.form.controls.title.value,
            url: this.form.controls.url.value
          }
        ).then(() => {
          this.db.sendMessage({
            topic: (this.form.controls.testonly.value ? 'isTestOnly/' : '') + 'Android',
            notificationtitle: this.form.controls.title.value,
            notificationmessage: this.form.controls.message.value,
          }).subscribe(() => {});
        });
      }
    }
  }
}